import React from 'react';

const ReservationDetail = ({ reservationDetails, isLoading, onClose, bookingId }) => {
    if (isLoading) {
        return (
            <tr>
                <td colSpan="8" style={{ backgroundColor: '#f8f9fa', padding: '20px', textAlign: 'center' }}>
                    <div className="d-flex justify-content-center align-items-center">
                        <div className="spinner-border" role="status">
                            <span className="sr-only">Loading...</span>
                        </div>
                        <span className="ml-2">Loading reservation details...</span>
                    </div>
                </td>
            </tr>
        );
    }

    if (!reservationDetails) {
        return (
            <tr>
                <td colSpan="8" style={{ backgroundColor: '#f8f9fa', padding: '20px', textAlign: 'center' }}>
                    <div className="alert alert-warning mb-0">
                        <i className="las la-exclamation-triangle mr-2"></i>
                        No details available for this reservation.
                        <button
                            type="button"
                            className="btn btn-outline-secondary btn-sm ml-3"
                            onClick={() => onClose(bookingId)}
                        >
                            Close
                        </button>
                    </div>
                </td>
            </tr>
        );
    }

    return (
        <tr>
            <td colSpan="8" style={{ backgroundColor: '#f8f9fa', padding: '0', border: 'none' }}>
                <div style={{ padding: '20px', position: 'relative' }}>
                    <button
                        type="button"
                        className="btn btn-outline-secondary btn-sm"
                        style={{ position: 'absolute', top: '10px', right: '10px'}}
                        onClick={() => onClose(bookingId)}
                    >
                        <i className="las la-times"></i> Close
                    </button>
                    
                    <h5 className="mb-3" style={{ paddingRight: '80px' }}>
                        Reservation Details
                    </h5>
                    
                    <div className="row">
                        <div className="col-md-6">
                            <div className="mb-3">
                                <strong className="text-primary">Reservation Information</strong>
                                <div className="mt-2">
                                    <p className="mb-1">
                                        <strong>Reservation No:</strong> {reservationDetails.Reservation_no}
                                    </p>
                                    <p className="mb-1">
                                        <strong>Date:</strong> {reservationDetails.date}
                                    </p>
                                    <p className="mb-1">
                                        <strong>Time Slot:</strong> {reservationDetails.sloteid}
                                    </p>
                                    <p className="mb-1">
                                        <strong>Order Time:</strong> {new Date(reservationDetails.order_time).toLocaleString()}
                                    </p>
                                    <p className="mb-1">
                                        <strong>Table No:</strong> {reservationDetails.table_no || 'Not assigned'}
                                    </p>
                                    <p className="mb-1">
                                        <strong>Number of Guests:</strong> {reservationDetails.n_o_g}
                                    </p>
                                    <p className="mb-1">
                                        <strong>Customer:</strong> {reservationDetails.initiator}
                                    </p>
                                    <p className="mb-1">
                                        <strong>Occasion:</strong> {reservationDetails.occasion}
                                    </p>
                                </div>
                            </div>
                        </div>
                        
                        <div className="col-md-6">
                            <div className="mb-3">
                                <strong className="text-primary">Payment Information</strong>
                                <div className="mt-2">
                                    <p className="mb-1">
                                        <strong>Food Charge:</strong> SAR {reservationDetails.food_charge}
                                    </p>
                                    <p className="mb-1">
                                        <strong>Reservation Charge:</strong> SAR {reservationDetails.res_charge}
                                    </p>
                                    <p className="mb-1">
                                        <strong>VAT:</strong> {reservationDetails.vat}%
                                    </p>
                                    <p className="mb-1">
                                        <strong>Total Amount:</strong> SAR {reservationDetails.total_amount}
                                    </p>
                                    <p className="mb-1">
                                        <strong>Payment Status:</strong> 
                                        <span 
                                            className={`badge ml-2 ${
                                                reservationDetails.payment_status === 'paid' ? 'badge-success' : 
                                                reservationDetails.payment_status === 'pending' ? 'badge-warning' :
                                                'badge-secondary'
                                            }`}
                                        >
                                            {reservationDetails.payment_status}
                                        </span>
                                    </p>
                                    <p className="mb-1">
                                        <strong>Balance to Pay:</strong> SAR {reservationDetails.pay_bal}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div className="row">
                        <div className="col-md-12">
                            <div className="mb-3">
                                <strong className="text-primary">Additional Information</strong>
                                <div className="mt-2">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <p className="mb-1">
                                                <strong>Status:</strong> 
                                                <span 
                                                    className={`badge ml-2 ${
                                                        reservationDetails.status === 'Booking Confirmed' ? 'badge-success' :
                                                        reservationDetails.status === 'Order Completed' ? 'badge-success' :
                                                        reservationDetails.status === 'Booking Pending' ? 'badge-warning' :
                                                        reservationDetails.status === 'Absent' ? 'badge-dark' :
                                                        'badge-dark'
                                                    }`}
                                                >
                                                    {reservationDetails.status}
                                                </span>
                                            </p>
                                            <p className="mb-1">
                                                <strong>Accepted:</strong> 
                                                <span className={` ml-2 ${reservationDetails.is_accepted ? 'text-success' : 'text-danger'}`}>
                                                    {reservationDetails.is_accepted ? 'Yes' : 'No'}
                                                </span>
                                            </p>
                                        </div>
                                        <div className="col-md-6">
                                            <p className="mb-1">
                                                <strong>Wallet Parking:</strong> 
                                                <span className={` ml-2 ${reservationDetails.wallet_parking ? 'text-success' : 'text-danger'}`}>
                                                    {reservationDetails.wallet_parking ? 'Yes' : 'No'}
                                                </span>
                                            </p>
                                            <p className="mb-1">
                                                <strong>Book for Friend:</strong> 
                                                <span className={` ml-2 ${reservationDetails.book_for_friend ? 'text-success' : 'text-danger'}`}>
                                                    {reservationDetails.book_for_friend ? 'Yes' : 'No'}
                                                </span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    {reservationDetails.foodItems && reservationDetails.foodItems.length > 0 && (
                        <div className="row">
                            <div className="col-md-12">
                                <div className="mb-3">
                                    <strong className="text-primary">Food Items</strong>
                                    <div className="mt-2">
                                        <div className="table-responsive">
                                            <table className="table table-sm table-bordered">
                                                <thead className="thead-light">
                                                    <tr>
                                                        <th>Item Name</th>
                                                        <th>Quantity</th>
                                                        <th>Price</th>
                                                        <th>Total</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {reservationDetails.foodItems.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>{item.name}</td>
                                                            <td>{item.quantity}</td>
                                                            <td>SAR {item.price}</td>
                                                            <td>SAR {(parseFloat(item.price) * parseInt(item.quantity)).toFixed(2)}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {(!reservationDetails.foodItems || reservationDetails.foodItems.length === 0) && (
                        <div className="row">
                            <div className="col-md-12">
                                <div className="alert alert-info">
                                    <i className="las la-info-circle mr-2"></i>
                                    No food items ordered for this reservation.
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </td>
        </tr>
    );
};

export default ReservationDetail;